import React, { useEffect, useState } from "react";
import { getFailureInvoiceList } from "../../../services/apiService";

const FailureInvoiceOrders = () => {
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);

  const fetchFailureOrders = async () => {
    try {
      const res = await getFailureInvoiceList();
      setData(res.data?.data || []);
    } catch (error) {
      console.error("Error fetching invoice failure list", error);
    }
  };

  useEffect(() => {
    fetchFailureOrders();
  }, []);

  // 🔍 SEARCH LOGIC
  const filteredData = data.filter((item) => {
    const searchText = search.toLowerCase();

    return (
      item.orderid?.toLowerCase().includes(searchText) ||
      item.customer_details?.[0]?.username
        ?.toLowerCase()
        .includes(searchText) ||
      item.customer_details?.[0]?.mobile
        ?.toString()
        .includes(searchText)
    );
  });

  // 📄 PAGINATION
  const totalPages = Math.ceil(filteredData.length / pageSize);
  const paginatedData = filteredData.slice(
    (page - 1) * pageSize,
    page * pageSize
  );

  return (
    <div className="invoice-wrapper">
      <h3 style={{ color: "green" }}>Failure Invoice Orders</h3>

      {/* Search */}
      <input
        type="text"
        placeholder="Search by Order ID / Mobile / Username"
        className="search-box"
        value={search}
        onChange={(e) => {
          setSearch(e.target.value);
          setPage(1);
        }}
      />

      {/* Table */}
      <table>
        <thead>
          <tr>
            <th>#</th>
            <th>Username</th>
            <th>Mobile</th>
            <th>Order ID</th>
            <th>Order Date</th>
            <th>Focus Message</th>
            <th>Re-Generate</th>
          </tr>
        </thead>
        <tbody>
          {paginatedData.length > 0 ? (
            paginatedData.map((item, index) => (
              <tr key={item.id}>
                <td>{(page - 1) * pageSize + index + 1}</td>
                <td>{item.customer_details?.[0]?.username}</td>
                <td>{item.customer_details?.[0]?.mobile}</td>
                <td>{item.orderid}</td>
              <td>
  {new Date(item.orderdate).toLocaleDateString("en-GB")}
</td>

                <td style={{ color: "black" }}>
                  {item.focusmsg}
                </td>
                <td>
                  <button className="regen-btn">
                    Generate Invoice
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7" style={{ textAlign: "center" }}>
                No records found
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* PAGINATION */}
    
<div className="pagination-container">


<div style={{color:"black"}}>

Items per page:


<select
className="page-select"
value={pageSize}
onChange={(e) => {
setPageSize(Number(e.target.value));
setPage(1);
}}
>

{[5,10,20,50].map((n)=>(
<option key={n} value={n}>
{n}
</option>
))}

</select>

</div>



<div className="page-buttons">

<button
className="page-btn"
disabled={page===1}
onClick={()=>setPage(page-1)}
>
Previous
</button>


<span className="page-count">

{page} / {totalPages || 1}

</span>


<button
className="page-btn"
disabled={page===totalPages || totalPages===0}
onClick={()=>setPage(page+1)}
>
Next
</button>

</div>


</div>

      {/* Styles */}
      <style>{`
        .search-box {
          padding: 6px;
          width: 300px;
          margin-bottom: 10px;
        }

        table {
          width: 100%;
          border-collapse: collapse;
        }

        th, td {
          border: 1px solid #ddd;
          padding: 10px;
          text-align: center;
        }

        th {
          background: #f3f3f3;
        }

        .regen-btn {
          background: #198754;
          color: white;
          border: none;
          padding: 6px 12px;
          border-radius: 4px;
          cursor: pointer;
        }

        .regen-btn:hover {
          background: #157347;
        }
      `}</style>
    </div>
  );
};

const paginationStyle = {
  display: "flex",
  justifyContent: "space-between",
  marginTop: "15px",
  alignItems: "center",
};

export default FailureInvoiceOrders;
